import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Home from "./pages/Home.tsx";
import { AppShell } from "@/components/layout/AppShell";

const FlightDetail = lazy(() => import("./pages/FlightDetail.tsx"));
const RouteResults = lazy(() => import("./pages/RouteResults.tsx"));
const AirportDetail = lazy(() => import("./pages/AirportDetail.tsx"));
const Reseservice = lazy(() => import("./pages/Reseservice.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<Home />} />
              <Route path="/flight/:id" element={<FlightDetail />} />
              <Route path="/route/:pair" element={<RouteResults />} />
              <Route path="/airport/:code" element={<AirportDetail />} />
              <Route path="/reseservice" element={<Reseservice />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
